import { render, staticRenderFns } from "./BookingRequests.vue?vue&type=template&id=38663d13&"
import script from "./BookingRequests.vue?vue&type=script&lang=ts&"
export * from "./BookingRequests.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports